import {Platform} from 'react-native';
import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
`;

export const Form = styled.View`
  margin-top: ${RFValue(4)}px;
`;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const InputGrid = styled.View`
  flex-direction: row;
  gap: ${RFValue(12)}px;
  justify-content: space-between;
  align-items: center;
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px 24px ${RFValue(16)}px;
`;

export const TypeSelector = styled.View`
  flex-direction: row;
  gap: ${RFValue(12)}px;
  margin-bottom: ${RFValue(16)}px;
`;

interface TypeButtonProps {
  selected?: boolean;
}

export const TypeButton = styled.TouchableOpacity<TypeButtonProps>`
  flex: 1;
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(8)}px;
  border-width: 2px;
  border-color: ${({selected, theme}) =>
    selected ? theme.colors.primary : theme.colors.border};
  background-color: ${({selected, theme}) =>
    selected ? theme.colors.primary + '10' : theme.colors.background};
  align-items: center;
  justify-content: center;
`;

export const TypeButtonText = styled.Text<TypeButtonProps>`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({selected, theme}) =>
    selected ? theme.colors.primary : theme.colors.text};
`;

export const SectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text_dark};
  margin-bottom: ${RFValue(12)}px;
`;

export const NoticeCard = styled.View`
  flex-direction: row;
  align-items: flex-start;
  background-color: ${({theme}) => theme.colors.loan_otp_icon_bg};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const NoticeIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.loan_otp_icon};
  margin-right: ${RFValue(10)}px;
  margin-top: ${RFValue(1)}px;
`;

export const NoticeText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(17)}px;
`;

export const BankInputContainer = styled.View`
  height: ${RFValue(45)}px;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const BankSelectorLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

interface BankSelectorValueProps {
  isPlaceholder?: boolean;
}

export const BankSelectorValue = styled.Text<BankSelectorValueProps>`
  flex: 1;
  font-size: ${RFValue(12)}px;
  color: ${({isPlaceholder, theme}) =>
    isPlaceholder ? theme.colors.placeholder : theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.title};
  padding: ${RFValue(20)}px ${RFValue(24)}px ${RFValue(8)}px;
`;

export const SearchForm = styled.View`
  margin:0 24px;
`;

export const DigitoLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const DigitoInputField = styled.TextInput`
  height: ${RFValue(45)}px;
  border-style: solid;
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetSearchInput = styled.TextInput`
  height: ${RFValue(42)}px;
  border-radius: ${RFValue(8)}px;
  border-width: 1.5px;
  border-color: ${({theme}) => theme.colors.border};
  padding: 0 ${RFValue(12)}px;
  margin: 0 ${RFValue(24)}px ${RFValue(8)}px;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetItem = styled.TouchableOpacity`
  padding: ${RFValue(14)}px ${RFValue(24)}px;
  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const BankSheetItemText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const BankSheetEmpty = styled.Text`
  text-align: center;
  padding: ${RFValue(20)}px;
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.placeholder};
  font-family: ${({theme}) => theme.fonts.regular};
`;

const bankDropdownMarginRight = Platform.select({
  android: RFValue(-14),
  ios: RFValue(-8),
});

const bankDropdownMarginBottom = Platform.select({
  android: RFValue(0),
  ios: RFValue(-2),
});

export const BankDropdownButton = styled.TouchableOpacity`
  height: ${RFValue(45)}px;
  width: ${RFValue(28)}px;
  margin-right: ${bankDropdownMarginRight}px;
  margin-bottom: ${bankDropdownMarginBottom}px;
  align-items: center;
  justify-content: center;
`;

export const BankDropdownIcon = styled(Feather)`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
